const langUserFirstLogin = {
	title: {
		tag: 'user.first_login.title',
		fr: 'Bienvenue dans le portail Sienna Investment Managers',
		en: 'Welcome to Sienna Investment Managers Portal',
	},
	btn_update_my_first_profile: {
		tag: 'user.first_login.btn_update_my_first_profile',
		fr: 'Mettre à jour mon profil',
		en: 'Update my profile',
	},
	btn_i_will_do_it_later: {
		tag: 'user.first_login.btn_i_will_do_it_later',
		fr: 'Je le ferai plus tard',
		en: 'I will do it later',
	},
	description: {
		tag: 'user.first_login.description',
		fr: "Pensez à prendre quelques instant pour définir vos préférences d'affichages, de notifications et de connexion",
		en: 'Please take a few minutes to set up your user profile preferences (display, connection and automated notifications).',
	},
	description2: {
		tag: 'user.first_login.description2',
		fr: 'Sauf modification de votre part via la page profile, vous serez dorénavant automatiquement notifié par e-mail lors de la mise à disposition de nouveaux rapports (gestion, CAC, AMPERE, VL).',
		en: 'From now on, you will be automatically notified by e-mail when a new report is available in SALT (management, accounting, NAV & AMPERE reports.',
	},
};

export default langUserFirstLogin;
